<template>
  <div class="l-edit-dialog-box">
    <el-form :model="form_data" label-width="120px" ref="form" :rules="rules" label-position="left" v-loading="loading">
      <el-row :gutter="50" style="margin-left:0;margin-right:0">
        <el-col :span="24">
          <el-form-item label="培训类别" prop="type_id">
              <el-cascader v-model="form_data.type_id" :options="tree_node" :props="{ checkStrictly: true }" @change="changeMaterialType(form_data.type_id)" clearable>
              </el-cascader>
          </el-form-item>
        </el-col>
        
        <el-col :span="12">
          <el-form-item label="培训分项名称" prop="material_name">
            <el-select v-model="form_data.material_name" placeholder="请选择培训名称" @change="changeMaterial(form_data.material_name)" clearable>
              <el-option v-for="item in material_list" style="width:50%" :key="item.id" :label="item.name" :value="item.name"> </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        
        <el-col :span="12">
          <el-form-item label="型号规格" prop="specification_id">
              <el-select v-model="form_data.specification_id" placeholder="请选择型号规格(如有)" @change="changeSpecification(form_data.material_name,form_data.specification_id)" clearable>
                <el-option v-for="item in specification_list" style="width:50%" :key="item.id" :label="item.name" :value="item.id"> </el-option>
              </el-select>
          </el-form-item>
        </el-col>
        
        <el-col :span="12">
          <el-form-item label="投放数量" prop="material_quantity">
            <el-input v-model="form_data.material_quantity" autocomplete="off" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        
        <el-col :span="12">
          <el-form-item label="库存单位" prop="material_sku_id">
              <el-select v-model="form_data.material_sku_id" placeholder="请选择库存单位" clearable>
                <el-option v-for="item in material_sku_list" style="width:50%" :key="item.id" :label="item.name" :value="item.id"> </el-option>
              </el-select>
          </el-form-item>
        </el-col>
        
        <el-col :span="12">
           <el-form-item label="开始培训日期" prop="producted_at">
               <el-date-picker v-model="form_data.producted_at" type="date" autocomplete="off" clearable
                 placement="bottom-start"
                 value-format="yyyy-MM-dd" placeholder="请选择开始培训时间" />
           </el-form-item>
           
         </el-col>

      </el-row>

    </el-form>
    <div class="l-dialog-footer">
      <el-button @click="cancel">取 消</el-button>
      <l-auth-button type="primary" auth="cabinet_template_detail_add_btn" @click="handleSubmit" :loading="submitting">确 认</l-auth-button>
    </div>

  </div>

    

</template>

<script>
import {
  types
} from './lavel.js';
// console.log(types)
export default {
  name: 'l-template-material-edit',
  props: {
    id: {
      type: [String, Number],
      default: null
    },
    // place_type: {
    //   type: [String, Number],
    //   default: null
    // },
    material_type: {
      type: [String, Number],
      default: null
    },
    visible: {
      type: Boolean,
    },
    useType: {
      type: [Number],
      default: 1
    },
  },

  components: {
  },
  computed: {
    hasId() {
      return this.$props.id !== null;
    },
    place_type_list() {
      return this.$store.state.list.place_type_list
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getData();

        }
      }
    },
    // "form_data.is_node"(val){
    //   if(val!=0){
    //     this.form_data.pid=""
    //   }
    // },
    // "form_data.pid"() {
    //   if (!this.getdata_flag) {
    //     this.form_data.type = ""
    //   } else {
    //     this.getdata_flag = false
    //   }
    //   this.changes();
    // }
  },
  data() {
    return {
        data: [],
        count: 0,
      loading: false,//页面是否加载中
      getdata_flag: false,
      LAVEL_LIST: types,
      //是否显示
      tree_node: [

      ],
      material_sku_list: [],
      //表单数据
      form_data: {
        // is_node: 0,
        // pid: "",
        material_name: '',
        material_code: '',
        // department_level: '',
        abbreviation: '',
        // place_type: '',
        // is_public: 1,
      },
      nodeList: [],
      material_list: [],
      specification_list: [],
      //分类
      sel_type_id: "",
      type_name: "",
      material_id: 0,
      //表单验证规则
      rules: {
        type_id: [
          { required: true, message: '器材分类不能为空', trigger: 'change' }
        ],
        material_name: [
          { required: true, message: '名称不能为空', trigger: 'change' }
        ],
        material_quantity: [
          { required: true, message: '投放数量不能为空', trigger: 'change' }
        ],
        producted_at: [
          { required: true, message: '出厂日期不能为空', trigger: 'change' }
        ],
        // decode: [
        //   { required: true, message: '编码不能为空', trigger: 'change' }
        // ],
        // pid: [
        //   { required: true, message: '所属上级不能为空', trigger: 'change' }
        // ],
      },
      //提交按钮是否显示加载中
      submitting: false,
    }
  },
  mounted() {

  },


  methods: {
    //点击取消通知父组件关闭对话框
    cancel() {
      this.$emit('update:visible', false);
    },
    func_click(e) {
      if (this.form_data.type == '' && e) {
        this.$alert('请先选择等级', '提示', {
          confirmButtonText: '确定'
        });
      }
    },
    // changes() {
    //   this.$_invoke("industry_getData", {
    //     type: this.form_data.type
    //   }).then((ret) => {  
    //     this.nodeList = ret.data
    //   })
    //     .finally(() => {
    //       this.loading = false;
    //     });
    // },

    //获取数据
    getData() {
//       this.$_invoke(`trainTemplate_saveData`, ).then((ret) => {
// console.log(ret);
//         this.tree_node = ret.tree_node;
//       }).finally(() => {
//         this.loading = false;
//       });
      // if (this.hasId) {
        this.loading = true;
        this.$_invoke(`trainTemplate_getMaterialList`, { id: this.$props.id }).then((ret) => {
            // this.data = ret.data;
            // this.count = ret.count;
          // this.form_data = ret.data;
          this.tree_node = ret.type_node;
          this.material_sku_list = ret.material_sku_list;
          this.getdata_flag = true
        }).finally(() => {
          this.loading = false;
        });
      // } else {
      //   // this.form_data.use_type = this.$props.useType
      // }

    },

    changeMaterialType(typeid) {
        console.log(typeid);
        let sel_type_id = typeid
        if (typeof sel_type_id != "number") {
          const pid_len = sel_type_id.length;
          sel_type_id = sel_type_id[pid_len - 1];
        }
        
        this.loading = true;
        this.$_invoke(`trainTemplate_getMaterialListByTypeId`, {sel_type_id }).then((ret) => {
            this.material_list = ret.material_list;
        }).finally(() => {
          this.loading = false;
        });
    },
    
    changeMaterial(materialname) {
        console.log(materialname);
        let sel_material_name = materialname
        
        this.loading = true;
        this.$_invoke(`trainTemplate_getSpecificationListByMaterialName`, {sel_material_name }).then((ret) => {
            this.specification_list = ret.specification_list;
        }).finally(() => {
          this.loading = false;
        });
    },

    changeSpecification(materialname,specificationid) {
        let sel_material_name = materialname
        let sel_specification_id = specificationid
        this.loading = true;
        this.$_invoke(`trainTemplate_getMaterialIdByMaterialNSpecification`, {sel_material_name,sel_specification_id })
            .then((ret) => {
                this.material_id = ret.material_id;
            })
            .finally(() => {
                this.loading = false;
            });
    },

    //提交数据
    handleSubmit() {
      if (this.loading) return;
      this.$refs.form.validate((valid) => {

        if (valid) {
          // let form_data = Object.assign({}, this.form_data);
          // if (typeof form_data.pid != "number") {
          //   const pid_len = form_data.pid.length;
          //   form_data.pid = form_data.pid[pid_len - 1];
          // }
          this.submitting = true;
          // this.form_data.place_type = 3;
          if (this.hasId) {//添加
            this.$_invoke('trainTemplate_saveMaterial', {material_id:this.material_id, id:this.$props.id
                , material_quantity:this.form_data.material_quantity
                , producted_at:this.form_data.producted_at}).then(() => {
              this.$_msg.success('添加消防器材成功');
              this.$emit('on-success');
              // this.getData();
            }).finally(() => {
              this.submitting = false;
            })
          } else {//修改
            
          }
        }
      })

    },
    
    //编辑/保存，改变状态
    edit(row, mode) {
        console.log(row.show);
        if (mode == "edit") {
            row.show = true;
        } else {
            row.show = false;
        }
    
        //save
        if (mode == "save") {
            this.submitting = true;
            if (this.hasId) {
                this.$_invoke('trainTemplate_updateMaterial', {id: row.id, 
                                                                material_quantity: row.material_quantity, 
                                                                producted_at: row.producted_at})
                    .then(() => {
                this.$_msg.success('修改消防器材成功');
                this.getData();
              }).finally(() => {
                this.submitting = false;
              })
            }
        }
    },
    
    //删除
    del(id) {
      this.$confirm("确定删除该条记录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$_invoke(`trainTemplate_deleteMaterial`, { id }).then((ret) => {
            if (ret != true) {
                this.$_msg.success("删除失败");
            } else {
                this.$_msg.success("删除成功");
                this.getData();
            }
          });
        })
        .catch(() => { });
    },
    
  },
}
</script>